// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"166":"daa5f3f6","533":"daa5f3f6","736":"daa5f3f6","880":"daa5f3f6","893":"daa5f3f6"}[chunkId] + ".chunk.css";
};